<ng-container *transloco="let _t">


<button *ngIf="showOrder"
	mat-icon-button 
	(click)="filterService.orderBy(prop, false, subObject)" 
	><mat-icon>arrow_drop_down</mat-icon></button>

<button *ngIf="showOrder"
	mat-icon-button 
	(click)="filterService.orderBy(prop, true, subObject)" 
	><mat-icon>arrow_drop_up</mat-icon></button>

<cmat-selector *ngIf="showFilter"#selector [prop]="prop"
	[values]="filterService.getFilterProperty(prop, subObject)"
	(changeTriggered)="filterService.filterBy(prop, $event, subObject);">
</cmat-selector>


</ng-container>